import { makeStyles } from 'tss-react/mui';

import { dFlex } from '@assets/mixins';

const useStyles = makeStyles<{ hasFarms: boolean }>()((_, { hasFarms }) => ({
  farm: {
    ...dFlex('start'),
  },
  riskLeveler: {
    justifyContent: 'flex-start !important',
  },
  box: {
    padding: 16,
    display: 'grid',

    ...(hasFarms && {
      padding: 0,
    }),
  },
  counter: {
    height: 30,
    justifyContent: 'center',
  },
  btnBox: {
    ...dFlex('end'),
    marginLeft: 'auto',
  },
}));

export default useStyles;
